/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementsuffix2Inputs */



/**
* | output |
* | --- |
* | "." |
*
* @param {Authagreementsuffix2Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementsuffix2 = /** @type {((inputs?: Authagreementsuffix2Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementsuffix2Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ (".")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ (".")
	if (locale === "de-DE") return /** @type {LocalizedString} */ (" zu.")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("。")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("에 동의하게 됩니다.")
	return /** @type {LocalizedString} */ ("に同意したものとみなされます。")
});
export { authagreementsuffix2 as "authAgreementSuffix" }